module.exports = __webpack_public_path__ + "img/car_front_right.09f1d3d7.svg";